export default __webpack_public_path__ + "static/media/saw-logo.c9a5cdd6.svg";